export const VERSIONS_TABLE_COLUMNS_NAME = [
  {
    label: 'Nombre',
    key: 'name',
  },
  {
    label: 'Marca',
    key: 'brand',
  },
  {
    label: 'Submarca',
    key: 'subBrand',
  },
  {
    label: 'Acciones',
    key: 'actions',
  },
];